export default "__VITE_ASSET__19b86619__"